<div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap=".5em">
    <mg-simple-form *ngIf="form" [formGroup]="form" [errorMessage]="errorMessage" label="Gebruiker" title="{{item?.firstName}} {{item?.lastName}}" (onSubmit)="onSubmit($event)" (onDelete)="onDelete()" [customActions]="customActions" [dtoClassName]="dtoTypeName">
        <mg-simple-form-section title="Algemeen">
            <mg-simple-form-row>
                <span>
                    <mat-form-field pd-size-max-spacer>
                        <input type="text" placeholder="Voornaam" matInput formControlName="firstName">
                        <mat-error>{{getError('firstName')}}</mat-error>
                    </mat-form-field>
                </span>
                <span>
                    <mat-form-field pd-size-max-spacer>
                        <input type="text" placeholder="Achternaam" matInput formControlName="lastName">
                        <mat-error>{{getError('lastName')}}</mat-error>
                    </mat-form-field>
                </span>
                <span>
                    <mat-form-field pd-size-max-spacer>
                        <input type="email" placeholder="Email" matInput formControlName="email">
                        <mat-error>{{getError('email')}}</mat-error>
                    </mat-form-field>
                </span>
            </mg-simple-form-row>
        </mg-simple-form-section>
        
        <mg-simple-form-section title="Beveiliging" *ngIf="!isNewItem && canCreate('AccessMonitor.Logic.User')">
            <mg-simple-form-row>
                <span>
                    <mat-slide-toggle color="accent" formControlName="locked">Geblokkeerd</mat-slide-toggle>
                    <mg-error-icon [error]="getError('locked')"></mg-error-icon>
                </span>
                <span></span>
                <span>
                    <mat-form-field>
                        <mat-datetimepicker #pickerlastPasswordChange type="datetime" timeInterval="5" [disabled]="true"></mat-datetimepicker>
                        <input matInput formControlName="lastPasswordChanged" [matDatetimepicker]="pickerlastPasswordChange" placeholder="Laatste keer wachtwoord gewijzigd" [disabled]="true">
                    </mat-form-field>
                </span>
            </mg-simple-form-row>
            <br>
            <label class="label-header">Two-Factor Authentication</label>
            <br><br>
            <mg-simple-form-row>
                <span>
                    <mat-slide-toggle color="accent" formControlName="mfaEnabled" >Geregistreerd door gebruiker</mat-slide-toggle>                
                </span>
            </mg-simple-form-row>
            <mg-simple-form-row>
                <span>
                    <mat-slide-toggle color="accent" formControlName="isMfaExempt" >Vrijgesteld van 2FA</mat-slide-toggle>                
                </span>
            </mg-simple-form-row>
        </mg-simple-form-section>
    </mg-simple-form>
    
    <div fxLayout="column" style="float: left;" > 
        <mat-tab-group>
            <ng-container *ngIf="!isNewItem && !isArchived()">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="col" style="margin-left: 20px;">Groepen</div>
                    </ng-template> 
                    <mg-subcollection title="Groepen" *mgIfCanRead="'Mango.Authorization.Group'" addable="false">
                        <mg-authorization-group-user-collection #collection [user]="this.item"></mg-authorization-group-user-collection>
                    </mg-subcollection>
                </mat-tab>
            </ng-container>
    
            <ng-container *ngIf="!isNewItem">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="col" style="margin-left: 20px;">Login Historie</div>
                    </ng-template> 
                    <mg-subcollection title="Login Historie" *mgIfCanRead="'Mango.Authentication.UserLoginHistory'" addable="false" deletable="false">
                        <user-login-history-collection #collection [user]="item" [defaultPageSize]="20"></user-login-history-collection>
                    </mg-subcollection>
                </mat-tab>
            </ng-container>
            <ng-container *ngIf="!isNewItem">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="col" style="margin-left: 20px;">Rechten</div>
                    </ng-template> 
                    <mg-user-roles-overview *mgIfCanRead="'Mango.Authorization.Role'" [showExplicitProperties]="false" [user]="this.item"></mg-user-roles-overview>
                </mat-tab>
            </ng-container>
        </mat-tab-group>
    </div>
    </div> 